import Col from 'react-bootstrap/lib/Col'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import Row from 'react-bootstrap/lib/Row'
import {Transition} from 'react-transition-group'
import times from 'lodash/times'
import {css} from 'glamor'

import ComfortSlider from './comfortSlider'
import SizeFitSlider from './sizeFitSlider'
import Stars from '../../../../components/stars'
import {colors} from '../../../../styles'
import {fadeInOutStyle} from '../../sharedStyles'

const style = {
  body: css({
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '5px'
  }),
  date: css({
    height: '14px',
    marginBottom: '9px',
    width: '6em'
  }),
  helpful: css({
    height: '11px',
    marginBottom: '29px',
    width: '20em'
  }),
  line: css({
    height: '12px',
    marginBottom: '8px',
    width: '48%'
  }),
  review: css({
    borderBottom: `1px solid ${colors.grayLighter}`,
    padding: '15px 0',
    '@media (max-width: 767px)': {
      margin: '0 -15px',
      padding: '15px'
    }
  }),
  shimmer: css({
    animation: 'shimmer 2s linear infinite',
    backgroundImage: `linear-gradient(to right, ${colors.grayLighter}, ${colors.grayLightest}, ${colors.grayLighter})`,
    backgroundPosition: 'top left',
    backgroundSize: '200% 100%'
  }),
  slider: css({
    marginBottom: '20px'
  }),
  stars: css({
    fontSize: '18px',
    lineHeight: '18px',
    marginBottom: '5px'
  }),
  title: css({
    height: '14px',
    marginBottom: '4px',
    width: '20em'
  })
}

class ReviewPlaceholder extends PureComponent {
  render() {
    return (
      <Transition in={this.props.in} timeout={250}>
        {(state) => {
          return (
            <div {...css(fadeInOutStyle.container, fadeInOutStyle[state])}>
              {times(this.props.count, (index) => (
                <div key={index} {...style.review}>
                  <Row>
                    <Col sm={12}>
                      <div {...style.stars}>
                        <Stars rating={0} />
                      </div>
                      <div {...style.date} {...style.shimmer} />
                    </Col>
                    <Col sm={12} md={6}>
                      <div {...style.title} {...style.shimmer} />
                      <div {...style.body}>
                        <div {...style.line} {...style.shimmer} />
                        <div
                          {...css(style.line, {
                            width: '33%'
                          })}
                          {...style.shimmer}
                        />
                      </div>
                      <div {...style.helpful} {...style.shimmer} />
                    </Col>
                    <Col sm={12} md={6}>
                      <div className="fitComfort">
                        <div {...style.slider}>
                          <SizeFitSlider value={0} />
                        </div>
                        <div {...style.slider}>
                          <ComfortSlider value={0} />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          )
        }}
      </Transition>
    )
  }
}

ReviewPlaceholder.propTypes = {
  in: PropTypes.bool,
  count: PropTypes.number
}

export default ReviewPlaceholder
